import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyBoardCanvasModernizationInternalOnboarding = () => {
  const BoardCanvasModernizationInternalOnboarding = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "board-canvas-modernization-internal-onboarding" */ './BoardCanvasModernizationInternalOnboarding'
      ),
    { namedImport: 'BoardCanvasModernizationInternalOnboarding' },
  );

  return (
    <ChunkLoadErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <BoardCanvasModernizationInternalOnboarding />
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};
